<template>
    <div class="q-pa-xs relative">
        <div class="row justify-between items-center q-mb-md absolute-top z-top bg" id="top">
            <h5 class="q-ma-xs">Фото</h5>
            <span v-if="!shared" class="q-ma-xs">Выбрано: {{ selected.length }}</span>
            <div>
                <q-btn v-if="!shared" :disable="selected.length === 0 && loading" round flat :loading="loading"
                    icon="more_vert" size="13px">
                    <q-menu auto-close>
                        <q-list style="min-width: 100px">
                            <q-item clickable @click="deletePhotos">
                                <q-item-section avatar>
                                    <q-icon name="delete" />
                                </q-item-section>
                                <q-item-section>Удалить</q-item-section>
                            </q-item>
                          <q-item clickable  @click="editDatePhoto">
                            <q-item-section>Изменить дату</q-item-section>
                          </q-item>
                            <q-item clickable @click="captionPhotos">
                                <q-item-section>Использовать подпись</q-item-section>
                            </q-item>
                            <q-item clickable @click="unCaptionPhotos">
                                <q-item-section>Не использовать подпись</q-item-section>
                            </q-item>
                            <q-item v-if="selected.length !== photos.length" clickable @click="selectAll">
                                <q-item-section>Выбрать все</q-item-section>
                            </q-item>
                            <q-item v-if="selected.length === photos.length" clickable @click="unSelectAll">
                                <q-item-section>Снять отметки</q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                </q-btn>
                <q-btn round flat :icon="grid ? 'view_list' : 'grid_view'" size="13px" @click="changeView" />
                <q-btn round flat icon="close" size="13px" @click="open = false" />
            </div>
        </div>

        <q-infinite-scroll class="q-mt-xl" ref="scrollArea" @load="load" :initial-index="-1">
            <div class="row q-gutter-sm justify-between q-px-md" id="photo-gallery">

                <q-img v-if="!shared" :src="photoPreviewUrl(photo)"
                    v-for="photo in photos" fit="cover" :ratio="16 / 9" :key="photo.id" @click="showPhoto(photo)"
                    :class="grid ? 'col-5' : 'col-12 '" v-ripple>
                    <q-checkbox :model-value="selected.includes(photo)"
                        class="absolute all-pointer-events q-pa-none q-ma-none" :size="grid ? 'xs' : 'sm'" dark
                        @update:model-value="v => selectPhoto(v, photo)">
                        <q-tooltip>
                            Выбрать
                        </q-tooltip>
                    </q-checkbox>
                </q-img>
                <q-img v-if="shared"
                    :src="photoSharedUrl(photo)"
                    v-for="photo in photos" fit="cover" :ratio="16 / 9" :key="photo.id" @click="showPhoto(photo)"
                    :class="grid ? 'col-5' : 'col-12 '" v-ripple>
                </q-img>
            </div>
            <template v-slot:loading>
                <div class="row justify-center q-my-md">
                    <q-spinner-dots color="primary" size="40px" />
                </div>
            </template>
        </q-infinite-scroll>
    </div>
</template>

<script setup lang="ts">
import { usePhotoStore } from "../../store/photo";
import { storeToRefs } from "pinia";
import { ref } from "vue";

import { Photo } from "../../models/task";
import { useEventBus } from "@vueuse/core";
import { photoKey } from "../../util/events";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import CopyProjects from "../CopyProjects.vue";
import PhotoOnlyDate from "../PhotoOnlyDate.vue";
import { photoCdnUrl } from "../../util/photoCdn";

const route = useRoute();
const $q = useQuasar()
const store = usePhotoStore()

const grid = ref(false)
const loading = ref(false)

const scrollArea = ref()
const { photos, open, shared, viewedImage, visibleViewer } = storeToRefs(store)
const selected = ref<Photo[]>([])
const photoEvent = useEventBus(photoKey)

const photoPreviewUrl = (photo: Photo) => photoCdnUrl(photo.address, {
    preview: '1280x960',
    formatAfterCaption: 'jpeg',
})

const photoSharedUrl = (photo: Photo) => {
    if (photo.caption) {
        return photoCdnUrl(photo.address, {
            preview: '1280x960',
            formatBeforeCaption: 'jpeg',
            formatAfterCaption: 'jpeg',
            caption: { text: photo.caption, fontSize: 30 },
        })
    }
    return photoCdnUrl(photo.address, {
        preview: '1280x960',
        formatAfterCaption: 'jpeg',
    })
}

photoEvent.on((event) => {
    if (event === 'load') {
        scrollArea.value.trigger()
    }
})

function load(index, done) {
    if (!shared.value) {
        store.load(index).then((v) => done(v))
    } else {
        done()
    }
}


function changeView() {
    grid.value = !grid.value
    if (!shared.value) {
        photos.value = []
    }
    scrollArea.value.setIndex(-1)
    scrollArea.value.resume()
    scrollArea.value.trigger()
}

function showPhoto(photo: Photo) {
    viewedImage.value = photos.value.indexOf(photo)
    visibleViewer.value = true
}

function selectPhoto(val: boolean, photo: Photo) {
    if (val) {
        selected.value = selected.value.concat([photo])
    } else {
        selected.value = selected.value.filter(v => v != photo)
    }
}


async function deletePhotos() {
    $q.dialog({
        title: 'Удаление',
        message: 'Вы уверены что хотите удалить эти фото',
        cancel: true,
        persistent: true
    }).onOk(async () => {
        loading.value = true
        for (const photo of selected.value) {
            await store.deletePhoto(photo)
        }
        selected.value = []
        photos.value = []
        scrollArea.value.setIndex(-1)
        scrollArea.value.resume()
        scrollArea.value.trigger()
        loading.value = false
    })
}


async function editDatePhoto() {
  if (selected.value.length === 0) {
    $q.notify({
      type: 'negative',
      message: 'Выберите фото для изменения даты'
    })
    return
  }
  $q.dialog({
    persistent: true,
    component: PhotoOnlyDate,
    componentProps: {
      photos: selected.value,
    },
  }).onOk(async ({newDate, latitude, longitude}) => {
    loading.value = true
    console.log(newDate, latitude, longitude)
    for (const photo of selected.value) {
      if (newDate) {
        await store.updateOnlyPhotoDate(photo, newDate)
      }
      if (latitude !== null && longitude !== null) {
        console.log("Change location", latitude, longitude)
        await store.updatePhotoLocation(photo, latitude, longitude)
      }
    }
    selected.value = []
    loading.value = false
  })
}


async function captionPhotos() {
    $q.dialog({
        title: 'Подпись',
        message: 'Вы уверены что хотите использовать подписи в фото',
        cancel: true,
        persistent: true
    }).onOk(async () => {
        loading.value = true
        for (const photo of selected.value) {
            await store.updatePhotoUseCaption(photo, true)
        }
        selected.value = []
        photos.value = []
        scrollArea.value.setIndex(-1)
        scrollArea.value.resume()
        scrollArea.value.trigger()
        loading.value = false
    })
}

async function unCaptionPhotos() {
    $q.dialog({
        title: 'Подпись',
        message: 'Вы уверены что хотите перестать использовать подписи в фото',
        cancel: true,
        persistent: true
    }).onOk(async () => {
        loading.value = true
        for (const photo of selected.value) {
            await store.updatePhotoUseCaption(photo, false)
        }
        selected.value = []
        photos.value = []
        scrollArea.value.setIndex(-1)
        scrollArea.value.resume()
        scrollArea.value.trigger()
        loading.value = false
    })
}

async function selectAll() {
    selected.value = photos.value
}

async function unSelectAll() {
    selected.value = []
}



</script>

<style scoped>
#top {
    background-color: white;
}
</style>
